import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11 1.834c-5.06 0-9.167 4.107-9.167 9.167S5.94 20.167 11 20.167s9.166-4.106 9.166-9.166S16.06 1.834 11 1.834m3.208 9.854h-2.521v2.521a.687.687 0 1 1-1.375 0v-2.521h-2.52a.687.687 0 1 1 0-1.375h2.52V7.792a.687.687 0 1 1 1.375 0v2.521h2.521a.687.687 0 1 1 0 1.375"
    }, null, -1)
  ])))
}
export default { render: render }